import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'

export const collection = 'deleteCasesActions'

export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi, apiBase: string) =>
  (
    _: unknown,
    {
      cascade,
      selectedCaseIds,
    }: { cascade: boolean; selectedCaseIds: string[] }
  ) =>
    callApi(`${apiBase}/cases/delete/multi`, schema, {
      method: 'POST',
      body: { caseIds: selectedCaseIds, cascade },
    })
